export default __webpack_public_path__ + "media/images/images_v2/shde-right3-cb92ef0f6df0ba028c11562893efe821.png";